module.exports = __webpack_public_path__ + "img/aerticket.8a640c64.png";